export default __webpack_public_path__ + "static/media/3.a20440d0.jpg";